export default "__VITE_PUBLIC_ASSET__66efa1c7__"